import {Component, Input} from '@angular/core';
import {isSmallerThanIpad} from '../../../../../helpers';

@Component({
  selector: 'app-inclusion-exclusion-list',
  templateUrl: './inclusion-exclusion-list.component.html',
  styleUrls: ['./inclusion-exclusion-list.component.css']
})
export class InclusionExclusionListComponent {

  @Input()
  itineraryTypeString: string;

  isSmallerThanIpad = isSmallerThanIpad;

  constructor() {
  }
}
